import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import PersonalCenter from '@/components/PersonalCenter'
import ErrorMessage from '@/components/ErrorMessage'
import MobileEnroll from '@/components/MobileEnroll'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:Uid/:ShareId',
            redirect: '/StaffLogin/:Uid/:ShareId'
        },
        {
            path: '/MobileEnroll/:Uid/:ShareId',
            name: 'MobileEnroll',
            component: MobileEnroll
        },
        {
            path: '/StaffLogin/:Uid/:ShareId',
            name: 'StaffLogin',
            component: resolve => require(['@/components/StaffLogin'], resolve)
        },
        {
            path: '/StaffMiniQr/:Uid/:ShareId',
            name: 'StaffMiniQr',
            component: resolve => require(['@/components/StaffMiniQr'], resolve)
        },
        {
            path: '/StaffCenter/:Uid/:ShareId',
            name: 'StaffCenter',
            component: resolve => require(['@/components/StaffCenter'], resolve)
        },
        {
            path: '/StaffCustommallOrder/:Uid/:ShareId',
            name: 'StaffCustommallOrder',
            component: resolve => require(['@/components/StaffCustommallOrder'], resolve)
        },
        // 统计报表
        {
            path: '/StaffCustommallCount/:Uid/:ShareId',
            name: 'StaffCustommallCount',
            component: resolve => require(['@/components/StaffCustommallCount'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/StaffCustommallCountChoice/:Uid/:ShareId',
            name: 'StaffCustommallCountChoice',
            component: resolve => require(['@/components/StaffCustommallCountChoice'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/StaffCustommallOrderDetailed/:Uid/:ShareId',
            name: 'StaffCustommallOrderDetailed',
            component: resolve => require(['@/components/StaffCustommallOrderDetailed'], resolve)
        },
        {
            path: '/StaffCustommallEventOrder/:Uid/:ShareId',
            name: 'StaffCustommallEventOrder',
            component: resolve => require(['@/components/StaffCustommallEventOrder'], resolve)
        },
        {
            path: '/StaffCustommallEventOrderDetailed/:Uid/:ShareId',
            name: 'StaffCustommallEventOrderDetailed',
            component: resolve => require(['@/components/StaffCustommallEventOrderDetailed'], resolve)
        },
        {
            path: '/StaffCustommallPeople/:Uid/:ShareId',
            name: 'StaffCustommallPeople',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/StaffCustommallPeople'], resolve)
        },
        {
            path: '/StaffCustommallPeopleOrder/:Uid/:ShareId',
            name: 'StaffCustommallPeopleOrder',
            meta: {
                keepAlive: true
            },
            component: resolve => require(['@/components/StaffCustommallPeopleOrder'], resolve)
        },
        {
            path: '/StaffRegister/:Uid/:ShareId',
            name: 'StaffRegister',
            component: resolve => require(['@/components/StaffRegister'], resolve)
        },
        {
            path: '/StaffCustommallPurchaseOrder/:Uid/:ShareId',
            name: 'StaffCustommallPurchaseOrder',
            component: resolve => require(['@/components/StaffCustommallPurchaseOrder'], resolve)
        },
        {
            path: '/StaffCustommallPurchaseOrderDetail/:Uid/:ShareId',
            name: 'StaffCustommallPurchaseOrderDetail',
            component: resolve => require(['@/components/StaffCustommallPurchaseOrderDetail'], resolve)
        },
        {
            path: '/StaffCustommallChangeNewOrder/:Uid/:ShareId',
            name: 'StaffCustommallChangeNewOrder',
            component: resolve => require(['@/components/StaffCustommallChangeNewOrder'], resolve)
        },
        {
            path: '/StaffCustommallChangeNewOrderDetail/:Uid/:ShareId',
            name: 'StaffCustommallChangeNewOrderDetail',
            component: resolve => require(['@/components/StaffCustommallChangeNewOrderDetail'], resolve)
        },
        {
            path: '*',
            name: 'ErrorMessage',
            component: ErrorMessage,
            children: [
                {path: 'ErrorEcho', component: ErrorMessage},
                {path: 'ErrorEcho/:Uid', component: ErrorMessage},
                {path: 'ErrorEcho/:Uid/:ShareId', component: ErrorMessage}
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js